'use strict';

/**
 *
 * @name: memberConfig
 *
 */

function MemberConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('MemberBundle');
  }

  $stateProvider
    .state('main.member', {
      url: 'member/:UserId/:displayName',
      controller: 'MemberController',
      templateProvider: $templateCache => $templateCache.get('member.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers,
        resolvedMemberUser: function(apiUserService, $stateParams, $q, $location, transObject, $rootScope) {
          var deferred = $q.defer();

          apiUserService
            .getAnotherUser($stateParams.UserId)
            .then(function(res) {

              if (res.data.roles.indexOf('contributor') > -1) {

                $location.path('/contributor/' + $stateParams.UserId + '/' + res.data.slug).replace();
              }
              if (res.data.roles.indexOf('brand') > -1) {

                $location.path('/brand/' + $stateParams.UserId + '/' + res.data.slug).replace();
              }

              if (res.data.loginSessions.length) {

                res.data.sNProfiles = [];
                res.data.loginSessions.forEach(function(item, index) {

                  res.data.sNProfiles[index] = item.loginProvider;
                });
              }
              deferred.resolve(res.data);
            }, function(err) {

              $rootScope.errorRedirect(err);
            });
          return deferred.promise;
        },
        resolvedMemberLoved: function(apiPostService, $q, $stateParams, transObject, $rootScope) {
          var deferred = $q.defer();

          apiPostService
            .getPost(false, 'loveCreatedAt', 1, 6, $stateParams.UserId)
            .then(function(res) {

              $rootScope.memberLovedTotalPagesTemp = res.data.meta.totalPages;

              res.data.items.forEach(function(item) {

                transObject.translate(item);
                transObject.getDuration(item);
                transObject.setBookmark(item);
                transObject.calendarDate(item);
                transObject.trueSlug(item);
              });

              deferred.resolve(res.data.items);
            }, function(err) {

              deferred.reject(err);
            });

          return deferred.promise;
        },
        resolvedMemberFollowing: function(apiUserService, $q, $stateParams, $rootScope, transObject) {

          var deferred = $q.defer();
          var following = {
            followers: [],
            followed: [],
            meta: {}
          };

          var followersCall = apiUserService.listUsers(1, 16, false, false, $stateParams.UserId, false);
          var followedCall = apiUserService.listUsers(1, 16, false, false, false, false, $stateParams.UserId);

          $q.all([followersCall, followedCall]).then(function(resArray) {

            resArray[0].data.items.forEach(function(item) {

              transObject.trueSlug(item);
            });

            resArray[1].data.items.forEach(function(item) {

              transObject.trueSlug(item);
            });

            following.followers = resArray[0].data.items;
            following.followed = resArray[1].data.items;
            following.meta.followerTotalPages = resArray[0].data.meta.totalPages;
            following.meta.followedTotalPages = resArray[1].data.meta.totalPages;

            deferred.resolve(following);
          }, function(err) {

            deferred.reject(err);
          });

          return deferred.promise;
        }

      }
    })
    .state('main.contributorSingle', {
      url: 'contributor/:UserId/:displayName',
      controller: 'ContributorSingleController',
      templateProvider: $templateCache => $templateCache.get('contributor-single.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers,
        resolvedContUser: function(apiUserService, $stateParams, $q, transObject, $location, $rootScope) {

          var deferred = $q.defer();

          apiUserService
            .getAnotherUser($stateParams.UserId)
            .then(function(res) {

              if (res.data.roles.indexOf('contributor') === -1 && res.data.roles.indexOf('brand') === -1) {

                $location.path('/member/' + $stateParams.UserId + '/' + res.data.slug).replace();
              }
              if (res.data.roles.indexOf('brand') >= 0) {

                $location.path('/brand/' + $stateParams.UserId + '/' + res.data.slug).replace();
              }

              res.data.professions.forEach(function(item) {

                transObject.translate(item);
              });

              deferred.resolve(res.data);
            }, function(err) {

              $rootScope.errorRedirect(err);
            });

          return deferred.promise;
        },
        resolvedContStories: function(apiPostService, $q, transObject, $stateParams) {

          var deferred = $q.defer();

          apiPostService
            .getPost(null, 'publishDate desc', 1, 4, null, null, true, null, $stateParams.UserId)
            .then(function(res) {

              res.data.items.forEach(function(item) {

                transObject.translate(item);
                transObject.getDuration(item);
                transObject.setBookmark(item);
                transObject.trueSlug(item);
              });

              deferred.resolve(res.data.items);
            }, function(err) {

              deferred.reject(err);
            });

          return deferred.promise;
        }
      }
    })
    .state('main.brandSingle', {
      url: 'brand/:UserId/:displayName',
      controller: 'BrandController',
      resolve: {
        moduleControllers: _resolveModuleControllers,
      },
      templateProvider: $templateCache => $templateCache.get('brand.index.html')
    })
    .state('main.contributorListing', {
      url: 'contributors',
      controller: 'ContributorListingController',
      resolve: {
        moduleControllers: _resolveModuleControllers,
      },
      templateProvider: $templateCache => $templateCache.get('contributor-listing.index.html')
    });
}

export default MemberConfig;



// WEBPACK FOOTER //
// ./app/pages/member/member.config.js